<template>
    <u-btn-arrow-outlined-tile v-bind="$attrs" @click="$emit('click')">
        <icon-arrow-primary v-bind="{ direction }" />
    </u-btn-arrow-outlined-tile>
</template>

<script>
import IconArrowPrimary from "@/components/publish/parents/icons/icon-arrow-primary.vue";
import UBtnArrowOutlinedTile from "@/components/publish/styles/buttons/u-btn-arrow-outlined-tile.vue";

export default {
    props: {
        direction: { type: String, default: "left" },
    },
    components: {
        IconArrowPrimary,
        UBtnArrowOutlinedTile,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
